import { connect } from 'react-redux';
import SequenceSelection from './SequenceSelection';
import { getLocationName } from '../../selectors/bookingLocation';
import { AppStep } from '../../reducers/navigation';
import { tryNavigateSequence, tryNavigateTo } from '../../actions/navigation';
import { trySelectSequence, clearSelectedSequence } from '../../actions/sequence';
import { setExtraLifeAutoComplete } from '../../actions/date';

const mapStateToProps = state => {
  return {
    locationName: state.bookingLocation.selectedLocation ? getLocationName(state.bookingLocation.selectedLocation) : '',
    selectedDate: state.date.selectedDate || new Date(),
    sequences: state.sequence.sequencesData,
    selectedSequence: state.sequence.selectedSequence,
    languageObj: state.language.sequence_selection_js,
    isExtraLife: state.date.isExtraLife,
    extraLifeAutoComplete: state.date.extraLifeAutoComplete
  };
}

const mapDispatchToProps = dispatch => ({
  transitionBack: () => dispatch(tryNavigateTo(AppStep.Date)),
  transitionForward: () => dispatch(tryNavigateSequence(true)),
  updateSequence: (sequence) => dispatch(trySelectSequence(sequence)),
  clearSequences: () => dispatch(clearSelectedSequence()),
  setExtraLifeAutoComplete: (toggleState) => dispatch(setExtraLifeAutoComplete(toggleState))
  // transitionForward: () => dispatch(tryNavigateTo(AppStep.Station))
});

export default connect(mapStateToProps, mapDispatchToProps)(SequenceSelection);
